<script setup>
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import InputField from '@js/components/fields/InputField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { reactive, ref, watch } from 'vue';
import { object, string } from 'yup';

const { configurationKey, title, label, callback } = defineProps({
    configurationKey: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isOpen = ref(false);

const loading = ref(true);

const isSubmitting = ref(false);

const form = reactive({
    value: null,
});

const validationSchema = object({
    value: string().required('Ce champ est obligatoire.'),
});

watch(isOpen, (value) => {
    if (value) {
        updateData();
    }
});

function updateData() {
    loading.value = true;

    axios
        .get(route('front.getConfiguration', { key: configurationKey }))
        .then((response) => {
            form.value = response.data.data.value;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

function submit() {
    isSubmitting.value = true;

    axios
        .post(route('front.postConfiguration', { key: configurationKey }), {
            data: {
                value: form.value,
            },
        })
        .then(() => {
            isOpen.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            isSubmitting.value = false;
        });
}
</script>

<template>
    <DialogDrawer v-model="isOpen" :loading="loading">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> {{ title }} </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <InputField
                            v-model="form.value"
                            :label="label"
                            field-name="value"
                            field-id="value"
                            type="text"
                            required
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                />
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
